/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const WSType = {
    ChatMessage: 'CHAT_MESSAGE',
    ChatViewed: 'CHAT_VIEWED',
    ChatActionsEdited: 'CHAT_ACTIONS_EDITED',
    ChatMessageDeleted: 'CHAT_MESSAGE_DELETED',
    ChatMessageEdited: 'CHAT_MESSAGE_EDITED',
    SystemNotification: 'SYSTEM_NOTIFICATION',
    SystemNotificationDeleted: 'SYSTEM_NOTIFICATION_DELETED',
    AdminVehicleRegistrationParsingFinished: 'ADMIN_VEHICLE_REGISTRATION_PARSING_FINISHED',
    AdminDriverLicenceParsingFinished: 'ADMIN_DRIVER_LICENCE_PARSING_FINISHED',
    AdminDriverDocumentParsingFinished: 'ADMIN_DRIVER_DOCUMENT_PARSING_FINISHED',
    WebLoadEdited: 'WEB_LOAD_EDITED',
    WebLoadDeleted: 'WEB_LOAD_DELETED',
    WebLoadDriverLocationChanged: 'WEB_LOAD_DRIVER_LOCATION_CHANGED',
    FleetBoardEdited: 'FLEET_BOARD_EDITED',
    DriverFilterEdited: 'DRIVER_FILTER_EDITED',
    DriverFilterPickupPointWarning: 'DRIVER_FILTER_PICKUP_POINT_WARNING',
    DriverLoadRateOffered: 'DRIVER_LOAD_RATE_OFFERED',
    DriverLoadRateCanceled: 'DRIVER_LOAD_RATE_CANCELED',
    DriverLoadRateRejected: 'DRIVER_LOAD_RATE_REJECTED',
    DriverLoadRateDeleted: 'DRIVER_LOAD_RATE_DELETED',
    DriverLoadAdded: 'DRIVER_LOAD_ADDED',
    DriverLoadEdited: 'DRIVER_LOAD_EDITED',
    DriverLoadDeleted: 'DRIVER_LOAD_DELETED',
    DriverLoadBoardLoadIgnored: 'DRIVER_LOAD_BOARD_LOAD_IGNORED',
    DriverLoadBoardCleared: 'DRIVER_LOAD_BOARD_CLEARED',
    DriverLoadDistance: 'DRIVER_LOAD_DISTANCE',
    DriverActiveLoadEdited: 'DRIVER_ACTIVE_LOAD_EDITED',
    DriverActiveLoadDeleted: 'DRIVER_ACTIVE_LOAD_DELETED',
    DriverRunLocationServiceChanged: 'DRIVER_RUN_LOCATION_SERVICE_CHANGED',
    CarrierRegistrationEdited: 'CARRIER_REGISTRATION_EDITED',
    CarrierRegistrationConfirmed: 'CARRIER_REGISTRATION_CONFIRMED',
    CarrierDocumentParsingFinished: 'CARRIER_DOCUMENT_PARSING_FINISHED'
} as const;
export type WSType = typeof WSType[keyof typeof WSType];

